import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { AbstractSpaceClass } from '../../../../../models/space/abstract-space.class';

export interface SaveSpaceOptions {
  space: AbstractSpaceClass;
  floors: Record<string, any>[];
  form: FormGroup;
}

export class SaveSpaceEvent<T = any> {
  constructor(
    public status: 'completed' | 'error',
    public args: T
  ) {}
}

export interface ICanSaveSPSpace {
  save(args: SaveSpaceOptions): Observable<SaveSpaceEvent>;
}

export interface SpaceSaveServiceFactory {
  getSpaceSaver(space: AbstractSpaceClass): ICanSaveSPSpace;
}
